import { render } from "./TreuhandAddAccountDialog.vue?vue&type=template&id=73e68404&ts=true"
import script from "./TreuhandAddAccountDialog.vue?vue&type=script&lang=ts"
export * from "./TreuhandAddAccountDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__